import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["shape"],
  _excluded2 = ["container"],
  _excluded3 = ["expandTrigger"];
import { ConfigProvider, Menu, Button, Icon, Balloon } from '@cainiaofe/cn-ui';
import { componentName } from "./const";
import View from "./view";
var Index;
if (!ConfigProvider || !Menu || !Button || !Icon || !Balloon || !(Balloon !== null && Balloon !== void 0 && Balloon.Tooltip)) {
  Index = function Index() {
    return null;
  };
} else {
  Index = ConfigProvider.config(View, {
    transform: /* istanbul ignore next */function transform(props, deprecated) {
      if ('shape' in props) {
        deprecated('shape', 'hasBorder', componentName);
        var _props = props,
          shape = _props.shape,
          others = _objectWithoutPropertiesLoose(_props, _excluded);
        props = _extends({
          hasBorder: shape !== 'arrow-only'
        }, others);
      }
      if ('container' in props) {
        deprecated('container', 'popupContainer', componentName);
        var _props2 = props,
          container = _props2.container,
          _others = _objectWithoutPropertiesLoose(_props2, _excluded2);
        props = _extends({
          popupContainer: container
        }, _others);
      }
      if ('expandTrigger' in props) {
        deprecated('expandTrigger', 'expandTriggerType', componentName);
        var _props3 = props,
          expandTrigger = _props3.expandTrigger,
          _others2 = _objectWithoutPropertiesLoose(_props3, _excluded3);
        props = _extends({
          expandTriggerType: expandTrigger
        }, _others2);
      }
      if ('showItemCount' in props) {
        deprecated('showItemCount', 'listStyle | listClassName', componentName);
      }
      if ('labelWidth' in props) {
        deprecated('labelWidth', 'listStyle | listClassName', componentName);
      }
      return props;
    }
  });
}
Index.displayName = componentName;
export default Index;